import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";


export default function InterviewGuide(response:any) {
  const [openSection, setOpenSection] = useState<number | null>(null);
  const guide = response?.response;
  const toggleSection = (index: number) => {
    setOpenSection(openSection === index ? null : index);
  };
  return (
    <div className="h-[90vh] max-w-5xl border rounded-xl border-gray-300 overflow-y-auto pn_scroller">
      <div className="bg-white border-b border-gray-200 ">
        <div className="p-3">
          <h1 className="text-lg font-bold text-gray-900 ">
            User Interview Discussion Guide
          </h1>
          <p className="text-xs text-gray-600">
            Research Objective: {guide?.research_objective}
          </p>
        </div>
      </div>
      {/* Introduction */}
      <div className="bg-white rounded-lg shadow border border-gray-200 mt-3 mx-2">
        <div className="p-3">
          <h2 className="text-md font-bold text-gray-900 mb-2">Introduction</h2>
          <div className="space-y-4">
            <div>
              <h3 className="font-semibold text-gray-900 text-md">Moderator Intro:</h3>
              <p className="text-gray-700 mt-1 text-xs">{guide?.introduction?.moderator_intro}</p>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 text-md">Participant Intro:</h3>
              <p className="text-gray-700 mt-1 text-xs">{guide?.introduction?.participant_intro}</p>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mt-4 text-md">Background Questions:</h3>
              <ul className="list-disc ml-6 space-y-3 mt-2 text-xs">
                {guide?.introduction?.background_questions.map((q:any, i:any) => (
                  <li key={i}>
                    <p className="font-medium text-gray-900">{q?.question}</p>
                    <ul className="list-disc ml-6 mt-1  text-gray-600 text-xs">
                      {q?.follow_ups?.map((f:any, j:any) => (
                        <li key={j}>{f}</li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* Sections */}
      <div className="space-y-2 mx-2 mt-4">
        {guide?.sections.map((section:any, idx:any) => (
          <div key={idx} className="bg-white rounded-lg shadow border border-gray-200 overflow-hidden">
            <button
              onClick={() => toggleSection(idx)}
              className="w-full p-3 flex items-center justify-between border-b border-gray-200 hover:bg-gray-50 transition-colors"
            >
              <span className="font-semibold text-gray-900 text-md">{section?.topic}</span>
              {openSection === idx ? (
                <ChevronDown className="w-2 h-2 text-slate-500" />
              ) : (
                <ChevronRight className="w-2 h-2 text-slate-500" />
              )}
            </button>
            {openSection === idx && (
              <div className="p-2">
                <div className="bg-white border-l-4 border-blue-500 rounded p-4">
                  <h3 className="text-md font-semibold text-gray-900 mb-3">
                    {section?.purpose}
                  </h3>
                  <ul className="list-decimal ml-6 space-y-3">
                    {section?.main_questions.map((q:any, qi:any) => (
                      <li key={qi}>
                        <p className="font-medium text-gray-900 text-xs">{q?.question}</p>
                        {q?.follow_ups && (
                          <ul className="list-disc ml-6 mt-1 text-xs text-gray-600 ">
                            {q?.follow_ups.map((f:any, fi:any) => (
                              <li key={fi}>{f}</li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      {/* Wrap Up */}
      <div className="bg-white rounded-lg shadow border border-gray-200 mt-4 mx-2 mb-4">
        <div className="p-3">
          <h2 className="text-md font-bold text-gray-900 mb-2">Session Wrap-Up</h2>
          <div className="space-y-4">
            <div>
              <h3 className="font-semibold text-gray-900 text-md">Closing Script:</h3>
              <p className="text-gray-700 mt-1 text-xs">{guide?.session_wrap_up?.closing_script}</p>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 text-xs">Feedback Questions:</h3>
              <ul className="list-disc ml-6 mt-2 text-gray-700 text-xs">
                {guide?.session_wrap_up?.feedback_questions.map((q:any, i:any) => (
                  <li key={i}>{q}</li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 text-xs">
                Incentive & Recording Notes:
              </h3>
              <p className="text-gray-700 mt-1 text-xs">{guide?.session_wrap_up?.incentive_and_recording_notes}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}